import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateCompaniesSubscriptionEntity } from '../../domain/entities/CreateUpdateCompaniesSubscriptionEntity'

export class CreateUpdateCompaniesSubscriptionModel extends CreateUpdateCompaniesSubscriptionEntity {
  constructor(dataDto: CreateUpdateCompaniesSubscriptionEntity) {
    super()
    mapEntityProperties<CreateUpdateCompaniesSubscriptionModel>(this, dataDto)
  }
}